//import { useState } from 'react';
import supabase from './supabaseClient';
//import { useAuth } from "./AuthContext";

function Login() {
  //const { login } = useAuth();

  // allow user to login or show error based on credentials entered.
   const handleSubmit = async (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;

    try {
      const { data, error } = await supabase
        .from('Users')
        .select('*')
        .eq('emailid', email)
        .eq('password', password);

      if (error) {
        alert('Login failed. Please try again.' + error.message);
        return;
      }

      if (data && data.length > 0) {
        const currentuser = data[0].userid;
        const action = 'login';
        
        const { error: insertError } = await supabase
          .from('UserActions')
          .insert([{ UserID: currentuser, Action: action }]);

        if (data[0].active === false) {

          const { data: config } = await supabase
          .from('AppConfig')
          .select('value')
          .eq('key', 'inactive_account_message')
          .single();
   

          const messageDiv = document.createElement('div');
          messageDiv.style.color = 'red';
          messageDiv.style.marginTop = '15px';
          messageDiv.innerText = config.value;
          const form = document.querySelector('form');
          form.parentNode.insertBefore(messageDiv, form.nextSibling);
          return;
        } 
        else {
          // Create a new session entry and fetch the token
          var sessionData, sessionError;
          const sessionResult = await supabase
            .from('UserSessions')
            .insert([{ userid: data[0].userid }])
            .select('token')
            .single();

          sessionData = sessionResult.data;
          sessionError = sessionResult.error;

          if (sessionError) {
            alert('Failed to create user session: ' + sessionError.message);
            return;
          }
          // alert('Your session token: ' + sessionData.token);
        }

        if (insertError) {
          alert('Failed to log user action:' + insertError.message);
        }
        else {
          // Successfully logged user action
          document.getElementById('userid-label').innerText = currentuser;

          window.location.href = '/?pageName=Profile&userid=' + (typeof sessionData !== 'undefined' ? data[0].userid + '-' + sessionData.token : '');  
        }

      } else {
        alert('Invalid email or password. Please try again.');
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      alert('An unexpected error occurred. Please try again later.' + err.message);
    }
  };

  const handleGuestLogin = async () => {
    try {
      const guestNameInput = document.getElementById('guestName');
      const guestName = guestNameInput && guestNameInput.value.trim();

      if (!guestName) {
        alert('Please enter your name. This is only for display on the screen during this session and will not be used for any other purpose.');
        return;
      }

      const { data, error } = await supabase
        .from('Users')
        .insert([{ username: guestName, isguest: true, active: true }])
        .select('userid')
        .single();

      if (error) {
        alert('Failed to create guest user: ' + error.message);
        return;
      }

      const guestUserId = data.userid;

      // Create a new session entry for the guest user
      const { data: sessionData, error: sessionError } = await supabase
        .from('UserSessions')
        .insert([{ userid: guestUserId }])
        .select('token')
        .single();

      if (sessionError) {
        alert('Failed to create guest session: ' + sessionError.message);
        return;
      }

      // Redirect to the profile page with the guest session token
      window.location.href = '/?pageName=Profile&userid=' + guestUserId + '-' + sessionData.token;
    } catch (err) {
      console.error('Unexpected error:', err);
      alert('An unexpected error occurred. Please try again later.');
    }
  };

  return (
    <div style={{ backgroundColor: 'white', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
          <input type="email" id="email" name="email" style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="password" style={{ display: 'block', marginBottom: '5px' }}>Password:</label>
          <input type="password" id="password" name="password" style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
        </div>
        <button type="submit" style={{ padding: '10px 20px', backgroundColor: 'blue', color: 'white', border: 'none', cursor: 'pointer' }}>Login</button>
      </form>
      <div style={{ marginTop: '20px' }}>
        <p>Don't have an account? <a href="?pageName=Register" style={{ color: 'blue' }}>Register here</a></p>
        <p>Forgot your password? <a href="?pageName=ForgotPassword" style={{ color: 'blue' }}>Click here to reset</a></p>
      </div>
      <div 
        style={{ 
          marginTop: '40px', 
          padding: '20px', 
          backgroundColor: '#e6f7ff', 
          border: '1px solid #91d5ff', 
          borderRadius: '5px' 
        }}
      >
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="guestName" style={{ display: 'block', marginBottom: '5px' }}>Enter your name:</label>
          <input 
            type="text" 
            id="guestName" 
            name="guestName" 
            placeholder="This name will be displayed on the screen and used to show your score in challenges" 
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} 
          />
        </div>
        <button 
          onClick={handleGuestLogin} 
          style={{ padding: '10px 20px', backgroundColor: '#1890ff', color: 'white', border: 'none', cursor: 'pointer' }}
        >
          Login as Guest
        </button>
        <p style={{ marginTop: '10px', color: '#595959' }}>
          Guest login provides temporary and short duration access. Data such as history and rankings will not be saved for guest users.
        </p>
      </div>
    </div>
  );
}

export default Login;